<template>
    <div class="form__group" :data-entry-not-valid="!isValid">
        <div class="form__group-content">
          <input
            :type="typeField"
            :autocomplete="autocomplete"
            class='form__input' :class="manageEntry('input')"
            @change="toAutoSave($event)"
            :placeholder="(placeholder.length?$t(placeholder):(indicator.length?$t(indicator)['placeholder']:''))"
            :required="required"
            v-model="valueIntern"
            @keyup="keyUpEvent($event)"
            @keydown="keyDownEvent($event)"
            @focusout="outEvent" />

          <svg v-show="showIcon()" :class="manageEntry('svgclass')">
            <use :href="manageEntry('svgpath')"></use>
          </svg>
        </div>
        <div class="form__group-indicator">
          <label v-if="doManageEntry && isFocusOut && !isValid" class="form__label form__label--error">
            {{ (labelError.length?$t(labelError):(indicator.length?$t(indicator)['labelError']:'')) }}
          </label>
          <label v-else class="form__label">
            {{ (label.length?$t(label):(indicator.length?$t(indicator)['label']:'')) }}
            </label>
        </div>
    </div>
</template>

<script>
import iconSVG from '../assets/sprite.svg'

export default {
  data: function () {
    return {
      isValid: true,
      isFocusOut: false
    }
  },
  computed: {
    valueIntern: {
      get () {
        return this.value
      },
      set (event) {
        this.$emit('input', event)
      }
    }
  },
  props: {
    typeField: {
      type: String,
      default: 'input'
    },
    indicator: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    labelError: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    autocomplete: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    maskOnValue: Function,
    maskOnKey: Function,
    compareValue: Boolean,
    hasToCompare: {
      type: Boolean,
      default: false
    },
    autoSave: {
      type: Boolean,
      default: false
    },
    returnKeyEvent: {
      type: Boolean,
      default: false
    },
    doManageEntry: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    manageEntry (widget) {
      if (!this.doManageEntry) {
        return
      }

      if (!this.required && this.value.trim().length === 0) {
        return
      }

      if (widget === 'input') {
        if (this.isFocusOut) {
          return {
            'form__input': 'true',
            'form__input--success': this.isValid,
            'form__input--error': !this.isValid
          }
        } else return { 'form__input': 'true' }
      } else if (widget === 'svgclass') {
        return {
          'form__icon--success': this.isValid,
          'form__icon--error': !this.isValid
        }
      } else if (widget === 'svgpath') {
        if (this.isValid) return `${iconSVG}#icon-check-circle`
        else return `${iconSVG}#icon-exclamation-circle`
      }
    },
    keyUpEvent (event) {
      // Test si regex de controle de saisie
      /* if (this.maskOnKey && !this.maskOnKey(event.key)) {
        event.preventDefault()
        return
      } */
      if (this.returnKeyEvent) this.$emit('entry:keyUp', event)
    },
    keyDownEvent (event) {
      this.isFocusOut = false

      // Test si regex de controle de touche ET que ce n'est pas enter, backspace, delete fleche gauche ou fleche droite
      if (this.maskOnKey && [13, 8, 46, 37, 39].indexOf(event.keyCode) === -1 && !this.maskOnKey(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    outEvent () {
      this.isFocusOut = true
      this.isValid = true
      // Champ requis et taille a 0
      if ((this.required === undefined || this.required) && !this.valueIntern.trim().length) {
        this.isValid = false
      }
      if (this.maskOnValue && this.valueIntern.trim().length) {
        this.isValid = this.maskOnValue(this.valueIntern)
      }
      if (this.hasToCompare) {
        this.isValid = this.compareValue
      }
    },
    toAutoSave () {
      if (this.autoSave) {
        this.$store.commit('entry/UPDATE_ASK_FOR_SAVE_ON_QUIT', true)
      }
    },
    showIcon () {
      if (!this.required && this.value.trim().length === 0) return false
      if (this.doManageEntry && this.isFocusOut) return true
      return false
    }
  }
}
</script>

<style lang="scss">
</style>
